import { render, staticRenderFns } from "./redo.vue?vue&type=template&id=45a40f7c&scoped=true&"
import script from "./redo.vue?vue&type=script&lang=js&"
export * from "./redo.vue?vue&type=script&lang=js&"
import style0 from "./redo.vue?vue&type=style&index=0&id=45a40f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a40f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
